import { VIZ_CATEGORICAL } from '@splunk/visualization-color-palettes';
import {
    COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
    enhanceOptionsSchemaWithDynamicOptions,
    getPattern,
    validTextOverflows,
} from '../utils';

export const linkGraphOptionsSchema = enhanceOptionsSchemaWithDynamicOptions({
    backgroundColor: {
        default: '> themes.defaultBackgroundColor',
        description:
            'Specify the color for the background. You may use a dataSource to apply the color. The default for enterprise light is "#ffffff". The default for enterprise dark is "#000000". The default for prisma dark is "#0b0c0e".',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        type: 'string',
    },
    fieldOrder: {
        default: '> primary | getField()',
        description:
            'Specify the order of fields to be displayed in the link graph from left to right when loaded. Unspecified fields will be excluded from the graph.',
        type: 'array',
        items: {
            type: 'string',
        },
    },
    linkColor: {
        default: '#6d6f76',
        description:
            'Specify the color used for highlighted links. Non-highlighted links will be displayed at 20% opacity.',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        type: 'string',
    },
    linkWidth: {
        default: 1,
        description: 'Specify, in pixels, the stroke width of each link.',
        type: 'number',
    },
    nodeColor: {
        default: '> themes.defaultNodeColor',
        description: 'Specify the color used for unhighlighted nodes.',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        type: 'string',
    },
    nodeTextColor: {
        description: 'Specify the color used for unhighlighted nodes text.',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        type: 'string',
        default: '> nodeColor | maxContrast(nodeTextColorMaxContrast)',
    },
    nodeLabelOverflow: {
        description:
            'Specify the text overflow for node labels. Valid types include "break-word", "anywhere", and "ellipsis".',
        type: 'string',
        pattern: getPattern(validTextOverflows as unknown as string[]),
        default: 'ellipsis',
    },
    nodeHeight: {
        default: 21,
        description: 'Specify, in pixels, the height of each node.',
        type: 'number',
    },
    nodeHighlightColor: {
        default: VIZ_CATEGORICAL[0],
        description: 'Specify the color used for highlighted nodes.',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        type: 'string',
    },
    nodeTextHighlightColor: {
        description: 'Specify the color used for highlighted nodes text.',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        type: 'string',
        default: '> nodeHighlightColor | maxContrast(nodeHighlightTextColorMaxContrast)',
    },
    nodeSpacingX: {
        default: 32,
        description: 'Specify, in pixels, the horizontal spacing between each node.',
        type: 'number',
    },
    nodeSpacingY: {
        default: 18,
        description: 'Specify, in pixels, the vertical spacing between each node.',
        type: 'number',
    },
    nodeWidth: {
        default: 180,
        description: 'Specify, in pixels, the width of each node.',
        type: 'number',
    },
    resultLimit: {
        default: 50,
        description: 'Specify the number of nodes rendered in each column.',
        type: 'number',
    },
    showNodeCounts: {
        default: true,
        description:
            'Specify whether a count is shown for the number of nodes displayed in each column. The number of total nodes is also shown if there are hidden nodes.',
        type: 'boolean',
    },
    showValueCounts: {
        default: true,
        description:
            'Specify whether a count is shown for the frequency of occurrence for each distinct node value.',
        type: 'boolean',
    },
});
